module.exports = __webpack_public_path__ + "img/douplus.abf89d1a.jpg";